var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.item.class},_vm._l((_vm.item.columns),function(column){return _c('div',{key:column._uid,class:column.class},_vm._l((column.content),function(_item){return _c('sb-render',{key:_item._uid,attrs:{"item":_item}})}),1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }